<template>
	<div class="form-group clearfix">
		<div
			:class="{'float-left': (field.labelStyle=='justify'||field.labelStyle=='inline')}"
		>
			<label v-if="field.question" class="mr-2 align-top">
				{{ field.question }}
				<span class="btn btn-primary btn-xs text-sm" @click="toggleInfo" v-if="hasInfo">Show Details</span>
			</label>
            <small 
                v-if="requiredIncomplete"
                class="ml-1" style="color:#FF0000"    
            >{{  $t('required')}}</small>
			<div v-if="field.description" v-html="field.description" class="mr-2"></div>
			<div v-if="(this.viewinfo && field.info)" v-html="field.info" class="mr-2 text-sm"></div>
		</div>
		<div :class="{'float-right': (field.labelStyle=='justify'),
        'requiredincomplete': requiredIncomplete
        }"
         v-bind:style="{ 'display': (field.labelStyle=='justify'||field.labelStyle=='inline'?'inline':'') }">
			<div id="chart" v-if="ready">
        		<apexchart ref="polarChart" type="polarArea" :options="chartOptions" :series="series"></apexchart>
      		</div>
		</div>
	</div>
</template>

<script>
export default {
	props: ['field', 'readonly','viewAs'],
  	components: {
  		apexchart: () => import('vue-apexcharts')
  	},
	data: function() {
		return {
			ready: false,
			maxvalue: 10,
			series: [],
			colors: [],
			labels: [],
			chartOptions: {},
			viewinfo: false
		}
	},
	mounted() {
		//this.getChartConfig();
		//this.ready = true;
	},
  	watch: {
  		field:{
  			handler: function(newVal){
				if(newVal && 'data' in newVal){
					if(newVal.data.length != this.series.length){
						this.getChartConfig();
						this.ready = true;
					}
				}
  			},
     		deep: true,
  			immediate: true
  		},
  		/*
  		series: {
  			handler: function(newVal, oldVal){
  				alert('here');
				if(newVal != oldVal){
					this.getChartConfig();
					this.ready = true;
				}
  			},
  			immediate: true

  		}
  		*/
  	},
	methods: {
		getChartConfig: function(){
			var self = this;

			this.series = [];
			this.colors = [];
			this.labels = [];
			for (var i in this.field.data) {
				if(Number(this.field.data[i].value)){
					this.series.push(Number(this.field.data[i].value));
				} else {
					this.series.push(0);
				}
				if('color' in this.field.data[i] && this.field.data[i].color && this.$config.getColorHexByName(this.field.data[i].color)){
					this.colors.push(this.$config.getColorHexByName(this.field.data[i].color));
				} else {
					this.colors.push(this.$config.getColorHexByIndex(i));
				}
				this.labels.push(this.field.data[i].caption);
			}

			this.chartOptions = {
				chart: {
					type: 'polarArea',
					events: {
						click: function(event, chartContext) {
							self.clickHandler(event, chartContext);
						}
					}
				},
				colors: self.colors,
				labels: self.labels,
				yaxis: {
					max: self.maxvalue,
				},
				stroke: {
					colors: ['#FFFFFF']
				},
				fill: {
					opacity: 0.8,
				},
				legend: {
					labels: {
          				useSeriesColors: false
          			}
          		},
				responsive: [{
					breakpoint: 2000,
					options: {
						chart: {
							width: 500
						},
						legend: {
							position: 'bottom'
						}
					}
				},{
					breakpoint: 480,
					options: {
						chart: {
							width: 200
						},
						legend: {
							position: 'bottom'
						}
					}
				}]
			}
		} ,
		clickHandler: function(event, chartContext) {
			if(this.readonly){
				return false;
			}

			var relPoint = this.pointToRelPoint(
				{
					x: (Math.round(chartContext.el.lastChild.offsetWidth/2) + chartContext.el.lastChild.getBoundingClientRect().left),
					y: (chartContext.pie.centerY + chartContext.el.lastChild.getBoundingClientRect().top)
				} ,
				{
					x: event.clientX,
					y: event.clientY
				}
			);

			var clickangle = Math.atan2(relPoint.x, -relPoint.y) * 180 / Math.PI;
			if(clickangle < 0){
				clickangle += 360;
			}

			var numsegments = this.series.length;
			var segradius = 360/numsegments;
			var segmentnumber = 0;
			for(var i=0; i<=360; i+=segradius){
				if(clickangle >= i){
					segmentnumber++;
				}
			}

			if(segmentnumber && segmentnumber<=this.series.length){
				var distance = Math.sqrt(Math.pow(relPoint.x , 2) + Math.pow(relPoint.y , 2));
				var newvalue = Math.ceil(distance/(chartContext.pie.defaultSize/(this.maxvalue*2)));
				if(newvalue <= this.maxvalue){
					this.field.data[segmentnumber-1].value = newvalue;
					this.series[segmentnumber-1] = newvalue;
					chartContext.updateSeries (this.series, false);
				}
			}
		} ,
		pointToRelPoint: function(center , point) {
			//alert(point.x);
			//alert(center.x);
        	return { x: point.x - center.x, y: point.y - center.y }
    	},
        hasData(array){
            return array.some(item => item.value > 0);
        },
        toggleInfo() {
        	this.viewinfo = !this.viewinfo;
        }
	},
    computed: {
        requiredIncomplete() {
            return (this.field.permission.includes(this.viewAs) || this.field.permission.length === 0) 
            && this.field.required && !this.hasData(this.field?.data);
        },
        hasInfo() {
        	if(this.field.info){
        		return true;
        	}
        	return false;
        }
    },
};
</script>
